import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import { useNotice, useDeleteNotice, forceReloadNotice } from '@hooks/API/Event/UseNotice';

import ObjectHistory from '@components/CreatedBy/ObjectHistory';
import { EventContainer, ObjectHistoryContainer } from '@components/EventDrawer/EventDrawerUi/EventUI';
import NoticeDetails from '@components/EventDrawer/NoticeEvent/NoticeDetails';
import NoticeForm from '@components/EventDrawer/NoticeEvent/NoticeForm';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const EventTitleContainer = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: ${(props) => (props.$isMobile ? '5rem 1.5rem 0 1.5rem' : '1.25rem 2rem 0 2.5rem')};

    .event-title-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 9rem;

        .project-send-button {
            font-size: 1.4rem;
        }
    }
`;

const NoticeEvent = ({
    ID,
    viewMode,
    plainMode,
    dateSelected,
    allDay,
    afterUpdate,
    afterRemove,
    onClose,
    onTouchForm,
}) => {
    const [noticeID, setNoticeID] = useState(ID);
    const { data: noticeData } = useNotice(noticeID);
    const [isEdit, setIsEdit] = useState(false);
    const { mutateAsync: onDeleteNotice } = useDeleteNotice();
    const [touchForm, setTouchForm] = useState(false);

    useEffect(() => {
        setNoticeID(ID);
    }, [ID]);

    const handleRemoveEvent = async (eventId) => {
        try {
            await onDeleteNotice({ ID: eventId, noticeId: noticeID });
            forceReloadNotice(ID);
        } catch (error) {
            console.error('Remove Notice Error => ', error);
        }
    };

    const handleClearTouchForm = () => {
        if (touchForm) {
            setTouchForm(false);
        }
    };

    const HeaderContent = () => (
        <div className="ant-drawer-header ant-drawer-header-sticky ">
            <div className="ant-drawer-title">{noticeData ? 'Notice' : 'Add New Notice'}</div>
        </div>
    );

    const NoticeFormContent = () => (
        <NoticeForm
            viewMode={viewMode}
            afterUpdate={afterUpdate}
            plainMode={plainMode}
            dateSelected={dateSelected}
            allDay={allDay}
            onTouchForm={(touchForm) => {
                if (noticeData) {
                    setTouchForm(touchForm);
                } else {
                    onTouchForm(touchForm);
                }
            }}
            onUpdateNoticeData={(noticeId) => {
                handleClearTouchForm();
                if (noticeId) {
                    setNoticeID(noticeId);
                } else {
                    forceReloadNotice(noticeId);
                }
            }}
            noticeData={noticeData}
            onCancel={() => {
                handleClearTouchForm();
                if (noticeData) {
                    setIsEdit(false);
                } else {
                    onClose();
                }
            }}
        />
    );

    const actions = [
        { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: () => setIsEdit(!isEdit) },
        {
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: async () => {
                await handleRemoveEvent(noticeData.ID);
                afterRemove(true);
            },
        },
    ];

    return (
        <EventContainer>
            <HeaderContent />
            {noticeData ? (
                <>
                    <EventTitleContainer>
                        <h2>
                            <strong>{noticeData.Title}</strong>
                        </h2>
                        <div>
                            <p>
                                <NwDropDownMenu right actions={actions} />
                            </p>
                        </div>
                    </EventTitleContainer>
                    <NoticeDetails noticeData={noticeData} />
                    <ObjectHistoryContainer>
                        <ObjectHistory asLine object={noticeData} />
                    </ObjectHistoryContainer>
                    {isEdit && (
                        <NwDrawer
                            padding="0px"
                            width={740}
                            touchForm={touchForm}
                            onTouchForm={setTouchForm}
                            title="Edit Notice"
                            onClose={() => {
                                setIsEdit(false);
                                handleClearTouchForm();
                            }}
                        >
                            <EventContainer>
                                <NoticeFormContent />
                            </EventContainer>
                        </NwDrawer>
                    )}
                </>
            ) : (
                !ID && <NoticeFormContent />
            )}
        </EventContainer>
    );
};

export default NoticeEvent;
